import { InvestorRequestPaymentMethod } from "@investorRequest/models";

export const INTERNAL_FUND_INFORMATION_TAB = "Internal Fund Information" as const;
export const EXTERNAL_FUND_INFORMATION_TAB = "External Fund Information" as const;

export interface DeriveIsInternalContextArgs {
  hasInternal: boolean;
  hasExternal: boolean;
  activeInfoTab: string | null | undefined;
  fundType?: string;
}

export const deriveIsInternalContext = ({
  hasInternal,
  hasExternal,
  activeInfoTab,
}: DeriveIsInternalContextArgs): boolean => {
  if (hasInternal && hasExternal) {
    return activeInfoTab === INTERNAL_FUND_INFORMATION_TAB;
  }

  if (hasInternal && !hasExternal) {
    return true;
  }

  if (!hasInternal && hasExternal) {
    return false;
  }

  return true;
};

export const deriveFundType = ({
  hasInternal,
  hasExternal,
  activeInfoTab,
}: DeriveIsInternalContextArgs): "Internal" | "External" | undefined => {
  if (hasInternal && hasExternal) {
    return activeInfoTab === INTERNAL_FUND_INFORMATION_TAB ? "Internal" : "External";
  }

  if (hasInternal && !hasExternal) {
    return "Internal";
  }

  if (!hasInternal && hasExternal) {
    return "External";
  }

  return undefined;
};

/** External fund contexts never support ACH — hybrid External tab, external-only users, or fundType External. */
export const isAchPaymentMethodDisabled = (args: DeriveIsInternalContextArgs): boolean => {
  if (args.fundType === "External") {
    return true;
  }

  return !deriveIsInternalContext(args);
};

export const resolveWirePaymentMethod = (
  paymentMethod: string | undefined,
  args: DeriveIsInternalContextArgs
): InvestorRequestPaymentMethod | "" => {
  const achDisabled = isAchPaymentMethodDisabled(args);

  if (paymentMethod === InvestorRequestPaymentMethod.FedWire) {
    return InvestorRequestPaymentMethod.FedWire;
  }

  if (paymentMethod === InvestorRequestPaymentMethod.Swift) {
    return InvestorRequestPaymentMethod.Swift;
  }

  if (paymentMethod === InvestorRequestPaymentMethod.Ach) {
    return achDisabled ? InvestorRequestPaymentMethod.FedWire : InvestorRequestPaymentMethod.Ach;
  }

  return achDisabled ? InvestorRequestPaymentMethod.FedWire : InvestorRequestPaymentMethod.Ach;
};
